
const localStorage = window.localStorage;

/* ------------------------ AUTH (ADMIN) ------------------------ */

export const storeTokens = async (token, refreshToken) => {
  await localStorage.setItem("jwt", token);
  await localStorage.setItem("refresh", refreshToken);
};

export const clearTokens = async () => {
  await localStorage.removeItem("jwt");
  await localStorage.removeItem("refresh");
};

export const getToken = async () => {
  const value = await localStorage.getItem("jwt");
  return value;
};

export const getRefreshToken = async () => {
  const value = await localStorage.getItem("refresh");
  return value;
};

/* ------------------------ CART ------------------------ */
// Storage can be unavailable (private browsing, blocked site data) so every access is guarded

const lsCart = "cart";

export const loadCart = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(lsCart));
    return Array.isArray(saved) ? saved : [];
  }
  catch (e) {
    return [];
  }
};

export const saveCart = (items) => {
  try {
    localStorage.setItem(lsCart, JSON.stringify(items));
  }
  catch (e) {
    /* Cart still works for this visit, it just won't be remembered */
  }
};

/* ------------------------ CHECKOUT DETAILS ------------------------ */
// Remembers the customer's details so they don't need to retype them if they cancel on the Yoco page

const lsCheckout = "checkoutDetails";

export const loadCheckoutDetails = () => {
  try {
    return JSON.parse(localStorage.getItem(lsCheckout)) || null;
  }
  catch (e) {
    return null;
  }
};

export const saveCheckoutDetails = (details) => {
  try {
    localStorage.setItem(lsCheckout, JSON.stringify(details));
  }
  catch (e) {
    /* Not critical */
  }
};
